import {
    PRESET_DELETE_SUCCESS, PRESETS_FETCH_FAILURE, PRESETS_FETCH_REQUEST,
    PRESETS_FETCH_SUCCESS, PRESET_SAVE_SUCCESS
} from '../actions/PresetActions';
import omit from 'lodash/omit';
import keyBy from 'lodash/keyBy';

export function singlePresetReducer(state, action) {
    switch (action.type) {
        case PRESET_SAVE_SUCCESS: {
            const {preset} = action;
            return preset;
        }
        default:
            break;
    }
    return state
}

export function presetsReducer(state = {items: {}}, action) {
    switch (action.type) {
        case PRESET_DELETE_SUCCESS: {
            const {id} = action;
            return {...state, items: omit(state.items, id)};
        }
        case PRESETS_FETCH_REQUEST: {
            return {...state, loading: true, fetched: null};
        }
        case PRESETS_FETCH_FAILURE: {
            const {error} = action;
            return {...state, loading: false, error, fetched: null};
        }
        case PRESETS_FETCH_SUCCESS: {
            const {presets} = action;
            return {fetched: new Date(), items: keyBy(presets, 'id')};
        }
        default: {
            const {id} = action;
            if (id) {
                const item = state.items[id] || {};
                const newItem = singlePresetReducer(item, action);
                if (newItem !== item) {
                    return {...state, items: {...state.items, [id]: newItem}};
                }
            }
            break;
        }
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/reducers/presets.js